function getPathStr(path) {
  const xPath = [];
  if (Array.isArray(path)) {
    path.forEach(node => {
      if (node.tagName) {
        const str = (node.tagName || '').toLocaleLowerCase();
        const id = !!node.id ? `#${node.id}` : '';
        const className = !!node.className ? `.${node.className.split(' ').join('.')}` : '';
        xPath.push(`${str}${id}${className}`);
      }
    });
  }
  return xPath.reverse().join('>');
}

function getTagUrl(node) {
  return node.src || node.href || '';
}

export function allBuryingPoint(buryingPoint) {
  /**
   * 界面元素点击事件埋点
   */
  document.body.addEventListener(
    'click',
    event => {
      const e = event || window.event;
      const { target = {}, path = [] } = e;
      const { id = '', tagName = '', textContent = '', className = '', nodeType = '' } = target || {};
      const param = {
        objectId: id,
        objectName: (tagName || '').toLocaleLowerCase(),
        objectContent: textContent,
        objectClassName: className,
        objectType: nodeType,
        objectSelector: getPathStr(path),
        objectTargetUrl: getTagUrl(target),
      };
      buryingPoint.send('ObjectClick', param);
    },
    false,
  );
}



// WEBPACK FOOTER //
// ./src/helper/divolte/globalBuryingPoint.js